import { useEffect, useState } from 'react'
import { Button, Dialog } from '@mui/material'
import Grid from '@mui/material/Grid'
import { ReactComponent as AddNoteTakerIcon } from 'assets/images/addNoteTaker.svg'
import OverlayLoading from 'components/atoms/OverlayLoading'
import NotificationSnackBar from 'components/molecules/notificationOverlay/NotificationSnackBar'
import colors from 'styles/colors'
import AddNoteTakerBody from 'components/molecules/myTeam/AddNoteTakerBody'
import { useTranslation } from 'react-i18next'
import { getLocalUser } from 'utils/localStorage'
import { updatePageState } from 'utils/windowHistoryHelper'
import { isAllowedFeature } from 'utils/permissionCheck'
import { FEATURE_KEYS } from 'services/constants'

const AddNoteTaker = ({ events, sucessCallback = () => {} }) => {
  const { t } = useTranslation()
  const [candidates, setCandidates] = useState([])
  const [loading, setLoading] = useState(false)
  const [open, setOpen] = useState(false)
  const [notiMessage, setNotiMessage] = useState('')
  const [showNotification, setShowNotification] = useState(false)
  const [isError, setIsError] = useState(false)
  const userId = getLocalUser()?.id

  useEffect(() => {
    let newCandidates = []
    for (const key in events) {
      if (events[key].some(x => !x.botId && x.eventId && x.userId === userId)) {
        newCandidates.push(
          ...events[key].filter(
            x => !x.botId && x.eventId && x.userId === userId
          )
        )
      }
    }
    setCandidates(newCandidates)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, events])

  useEffect(() => {
    if (window.history?.state?.usr?.openAddNoteTaker) {
      setOpen(true)
      updatePageState({ usr: { openAddNoteTaker: false } })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.history?.state])

  const onSuccess = () => {
    setNotiMessage(t('myTeam.noteTakerAdded'))
    setShowNotification(true)
    sucessCallback()
    setOpen(false)
    setIsError(false)
  }

  const onError = () => {
    setIsError(true)
    setShowNotification(true)
  }

  const hasOneOnOneLicense = isAllowedFeature(FEATURE_KEYS.ONE_ON_ONE_PAID)

  return (
    <>
      {hasOneOnOneLicense && candidates.length > 0 && (
        <>
          <Button
            startIcon={<AddNoteTakerIcon />}
            onClick={() => setOpen(true)}
            variant='outlined'
            color='primary'
            size='small'
            sx={{
              height: 36,
              '&:hover': {
                '--path-color': colors.White
              }
            }}>
            {t('contact.addNoteTaker')}
          </Button>

          <Dialog open={open} onClose={() => setOpen(false)}>
            <OverlayLoading open={loading} />
            <Grid
              container
              padding={12}
              sx={{
                width: 568,
                height: 700,
                paddingTop: 20
              }}>
              <AddNoteTakerBody
                candidates={candidates}
                setLoading={setLoading}
                onSuccess={() => onSuccess()}
                onError={() => onError()}
                cancelBtnAction={() => setOpen(false)}
              />
            </Grid>
          </Dialog>
        </>
      )}
      <NotificationSnackBar
        open={showNotification}
        error={isError}
        success={!isError}
        successText={notiMessage}
        setOpen={setShowNotification}
      />
    </>
  )
}

export default AddNoteTaker
